module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "box"
  }, [_vm._l((_vm.row.doing), function(item, index) {
    return _c('div', {
      directives: [{
        name: "rblink",
        rawName: "v-rblink",
        value: ({
          name: 'ISaiApplyFormStep1',
          'query': {
            'saiqu_id': item.id
          }
        }),
        expression: "{name:'ISaiApplyFormStep1','query':{ 'saiqu_id':item.id }}"
      }],
      key: index,
      staticClass: "active-item",
      staticStyle: {
        "margin-bottom": "20px",
        "border-bottom": "1px solid #00000010",
        "padding-bottom": "10px"
      }
    }, [_c('p', {
      staticClass: "active-item-name"
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('div', {
      staticClass: "active-item-info"
    }, [_c('img', {
      attrs: {
        "src": item.pic_url,
        "alt": "",
        "srcset": ""
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "info-top-left"
    }, [_vm._v("正在进行")]), _vm._v(" "), _c('div', {
      staticClass: "info-bottom"
    }, [_c('div', {
      staticClass: "left"
    }, [_c('span', [_vm._v(_vm._s(item.member_count) + "人参加")])]), _vm._v(" "), _c('div', {
      staticClass: "right"
    }, [_c('span', [_vm._v(_vm._s(item.saidate_str))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.province) + " " + _vm._s(item.city) + " ")])])])])])
  }), _vm._v(" "), (_vm.row.going.length > 0) ? _c('div', {
    staticStyle: {
      "width": "7rem",
      "margin": "0 auto",
      "margin-top": "20px"
    }
  }, [_c('div', {
    staticClass: "in-active-start"
  }, [_vm._v("即将开始")]), _vm._v(" "), _vm._l((_vm.row.going), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "active-start"
    }, [_vm._m(0, true), _vm._v(" "), _vm._m(1, true)])
  })], 2) : _vm._e(), _vm._v(" "), (_vm.row.pass.length > 0) ? _c('div', {
    staticClass: "more-box",
    staticStyle: {
      "display": "none"
    }
  }, [_c('div', {
    staticClass: "more-active"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    directives: [{
      name: "rblink",
      rawName: "v-rblink",
      value: ({
        name: 'SaiDateList',
        query: {}
      }),
      expression: "{name:'SaiDateList',query:{}}"
    }],
    staticStyle: {
      "display": "flex",
      "align-items": "center"
    }
  }, [_c('div', {
    staticClass: "more-right"
  }, [_vm._v("更多")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../../assets/images/arrow.png"),
      "alt": "",
      "srcset": ""
    }
  })])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex",
      "justify-content": "space-between"
    }
  }, _vm._l((_vm.row.pass), function(item, index) {
    return _c('div', {
      directives: [{
        name: "rblink",
        rawName: "v-rblink",
        value: ({
          name: 'ActivityActivity',
          'query': {
            id: item.activity_id
          }
        }),
        expression: "{name:'ActivityActivity','query':{id:item.activity_id}}"
      }],
      key: index,
      staticClass: "more-active-address address-box1"
    }, [_c('p', {
      staticClass: "address-box-top"
    }), _vm._v(" "), _c('p', {
      staticClass: "address-box-main"
    }, [_vm._v(_vm._s(item.city))]), _vm._v(" "), _c('p', {
      staticClass: "address-box-bottom"
    }, [_vm._v(_vm._s(item.saidate_str))])])
  }), 0)]) : _vm._e(), _vm._v(" "), _c('TabBar', {
    attrs: {
      "show-tab-bar": _vm.showTabBar
    }
  }), _vm._v(" "), _c('LoginDialog', {
    attrs: {
      "show": _vm.loginShow
    },
    on: {
      "loginSuccess": _vm.loginSuccess,
      "loginCancel": _vm.loginCancel
    }
  })], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "left"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/images/pic-active-pic2.png"),
      "alt": "",
      "srcset": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "bottom"
  }, [_c('span', [_vm._v("2020-12-01")]), _vm._v(" "), _c('span', [_vm._v("中国·南京")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "right"
  }, [_c('p', {
    staticClass: "start-item-title"
  }, [_vm._v("2019-2020年全国啦啦操联赛（上海闵行站）")]), _vm._v(" "), _c('div', {
    staticClass: "start-time"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/images/icon-time.png"),
      "alt": "",
      "srcset": ""
    }
  }), _vm._v(" "), _c('span', [_vm._v("2天21：27：12开始")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex",
      "justify-content": "space-around"
    }
  }, [_c('span', {
    staticClass: "into"
  }, [_vm._v("进入")]), _vm._v(" "), _c('span', {
    staticClass: "join"
  }, [_vm._v("报名")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "display": "flex",
      "align-items": "center"
    }
  }, [_c('div', {
    staticClass: "solid"
  }), _vm._v(" "), _c('span', {
    staticClass: "more-title"
  }, [_vm._v("往期活动")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-91e2504a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/activity/Activity.vue
// module id = 1504
// module chunks = 0